import { CHECKOUT_URL } from "../../lib/assets";
import { CTAButton } from "./CTAButton";

export const FinalCTA = () => {
  return (
    <section
      className="relative py-32 md:py-48 overflow-hidden bg-[#F7E9EC] border-t border-[#EDD9DE]"
      data-testid="final-cta-section"
    >
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(201,88,126,0.10) 0%, transparent 70%)",
        }}
      />

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <p className="font-body uppercase tracking-[0.4em] text-[10px] md:text-xs text-[#C9587E] font-semibold mb-10">
          No Calls · No Calendar · No Masking
        </p>

        <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl font-light leading-[0.95] tracking-tight text-[#3B2630]">
          Just your voice in my ear
          <span className="block italic text-[#C9587E] mt-3">
            and mine in yours.
          </span>
        </h2>

        <p className="font-serif italic text-xl md:text-2xl text-[#6B5058] max-w-2xl mx-auto mt-12 leading-relaxed">
          Starts the moment you enroll. Your first voice note could be tonight.
        </p>

        <div className="mt-16 flex items-center justify-center">
          <CTAButton variant="primary" href={CHECKOUT_URL} testid="final-cta">
            Leggo
          </CTAButton>
        </div>

        <p className="font-body text-sm text-[#97808A] mt-12 max-w-md mx-auto">
          Spots available until July 31st, then the investment doubles.
        </p>
      </div>
    </section>
  );
};
